import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { LoggerService } from '../shared/logger.service';
import { BehaviorSubject, Subscription } from 'rxjs';

import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { StorageService } from '../auth/storage.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-casi-projects',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    FontAwesomeModule
  ],
  templateUrl: './casi-projects.component.html',
  styleUrl: './casi-projects.component.scss'
})
export class CasiProjectsComponent implements OnInit, OnDestroy {

  private _selectedProject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  get selectedProject() {
    return this._selectedProject.getValue();
  }
  set selectedProject(val: string) {
    this._selectedProject.next(val);
  }

  private _subs: Subscription[] = [];

  constructor(private logger: LoggerService,
    private storage: StorageService,
    public faIcons: FaIconLibrary,
    private scroller: ViewportScroller,
    private activeRoute: ActivatedRoute
  ) {
    faIcons.addIcons(...all);
  }

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    // this.view = this.dataService;
    this._subs.push(this.activeRoute.fragment.subscribe(frag => {
      this.logger.debug('ngOnInit:frag: ', frag);
      this.selectProject(frag!);
    }));
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  selectProject(val: string) {
    this.logger.debug(`selecteProject: `, val);
    this.selectedProject = val;
    setTimeout(() => {
      this.scroller.scrollToAnchor(this.selectedProject);
    })
  }

  backToTop() {
    this.logger.debug(`backToTop...`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
